module.exports = __webpack_public_path__ + "static/media/fi-FI.3d6e7381.md";